import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { RoundedCurrencyPipe } from '@innogy/utils-deprecated';
import { ToolTipComponent } from '@legacy/common-ui-utility-components';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';

@Component({
  selector: 'wl-commodity-price-breakdown-row',
  templateUrl: './commodity-price-breakdown-row.component.html',
  styleUrls: [
    './commodity-price-breakdown-row.component.ed.scss',
    './commodity-price-breakdown-row.component.essent.scss',
  ],
  standalone: true,
  imports: [
    CommonModule,
    CSCaptureDirective,
    ToolTipComponent,
    RoundedCurrencyPipe,
    AutomationIdDirective,
  ],
})
export class CommodityOfferPriceBreakdownRowComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() subtitle?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() costWithDiscount?: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() costWithoutDiscount?: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() tooltipDescription?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() discountPrice?: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() alignPriceHorizontal? = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isBBA? = false;

  get costWithoutDiscountClasses(): { [key: string]: boolean } {
    return {
      'gray-text text-decoration-line-through':
        !!this.discountPrice && !this.isBBA,
      'fw-bold': !this.discountPrice || !!this.isBBA,
    };
  }

  get subTitleValue(): string | undefined {
    return this.isBBA || this.discountPrice ? this.subtitle : undefined;
  }
}
